<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini" inline>
            <el-form-item  label="开票时间" >{{formData.invoiceDate}}</el-form-item>
            <el-form-item  label="发票代码" >{{formData.invoiceCode}}</el-form-item>
            <el-form-item  label="发票号码" >{{formData.invoiceNum}}</el-form-item>
            <el-form-item  label="全电发票号码" >{{formData.electronicNumber}}</el-form-item>
            <el-form-item  label="销售方" >{{formData.sellerName}}</el-form-item>
            <el-form-item  label="购买方" >{{formData.buyerName}}</el-form-item>
            <el-form-item  label="发票状态" >{{formData.invoiceStatus}}</el-form-item>

            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true"
                    @select="handleSelectionChange"
                    style="width: 100%;margin-right: 9px;margin-left: 9px">
<!--                <el-table-column  label="序号" align="center" type="index" width="45px"></el-table-column>-->
                <el-table-column align="center" type="selection" width="50px"></el-table-column>
                <el-table-column align="center" label="开票时间" prop="invoiceDate"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="开票方" prop="sellerName"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="发票号码" prop="invoiceNum"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="全电发票号码" prop="electronicNumber"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="发票状态" width="70px" prop="invoiceStatus"  show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="开票金额" prop="invoiceAmount"    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="text-align: right">{{scope.row.invoiceAmount}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('form_notes')" prop="note"    show-overflow-tooltip></el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" layout="total,prev, pager, next" :current-page.sync="currentPage" :total="total" :page-size="pageSize">
            </el-pagination>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >关联</el-button>
            <!--                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        let curDate=(new Date()),perM;
                        if(curDate.getMonth()>0){
                            perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                        }else{
                            perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                        }
                        let today=(new Date()).getDate();
                        let same=today*24*3600*1000;
                        // let sameMonth=curDate-same;//当月月初
                        let sameMonth=perM;
                        return time.getTime() > Date.now() || time.getTime() < sameMonth;
                        // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                        // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的

                    }
                },
                baseerp:'',
                canEdit:false,
                formData:{
                },
                tableData:[],
                tableHeight:0,
                currentPage: 1,
                pageSize: 20,
                total:0,
                chooseData:[],
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.recordId;
                        this.formData=JSON.parse(JSON.stringify(this.data));
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.withInvoiceServer();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            // editForm(){
            //     this.canEdit=true
            // },
            handleSelectionChange(val,row) {
                //console.log('re',row)
                let multipleSelection = val;
                if(multipleSelection.length>1){
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(row,true);
                }
                    this.chooseData=row

            },
            cancel(){
                this.$emit('close')
            },
            async withInvoiceServer(){
                let param={
                    serviceType:4,
                    getBluesParam:{
                        companyId:this.formData.companyId,
                        companyName:this.formData.buyerName,
                        customerId:this.formData.customerId,
                        customerName:this.formData.sellerName,
                        currentPage:this.currentPage,
                        pageSize:this.pageSize,
                    }
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.blueInvoices;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            saveForm(){
                if(this.chooseData.length==0){
                    this.$message.warning('请选择蓝票数据')
                }else{
                    this.withInvoiceServer5()
                }
            },
            async withInvoiceServer5(){
                let param={
                    serviceType:5,
                    associateBlueParam:{
                        redRecordId:this.formData.recordId,
                        blueRedRecordId:this.chooseData.recordId,
                        isUse:this.chooseData.isUse,
                        blueInvoiceNum:this.chooseData.invoiceNum?this.chooseData.invoiceNum:this.chooseData.electronicNumber,
                    }
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.withInvoiceServer();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>